import React from 'react';
import { motion } from "framer-motion";
import tv from "../assets/tv.png";
import saveButton from "../assets/save button.png";
import rightArrow from "../assets/next button.png";
import leftArrow from "../assets/previous button.png";

export default function RandomMeme({
  randomImage,
  showPrevious,
  handleDownloadImage,
  chooseRandom
}) {
  // Handle case where randomImage is not loaded yet
  if (!randomImage) {
    return (
      <div className="image-container">
        <div className="loading-state">Loading memes...</div>
      </div>
    );
  }

  return (
    <div className="image-container">
      {randomImage.type !== "video/mp4" ? (
        <>
          <img
            alt={`Meme: ${randomImage.tags?.join(', ') || 'Random meme'}`}
            src={randomImage.source}
            className="base-image"
          />
          <img alt="TV frame overlay" src={tv} className="tv-overlay" />
        </>
      ) : (
        <>
          <video
            autoPlay={true}
            controls={true}
            loop={true}
            muted={false}
            src={randomImage.source}
            className="base-image"
            aria-label={`Video: ${randomImage.tags?.join(', ') || 'Random meme video'}`}
          />
          <img alt="TV frame overlay" src={tv} className="tv-overlay" />
        </>
      )}

      <div className="tv-button">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={showPrevious}
          className="nav-button"
          aria-label="Previous meme"
        >
          <img alt="" className="arrow-button left" src={leftArrow} />
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleDownloadImage(
            randomImage.source,
            randomImage.tags?.[0] || 'meme',
            randomImage.type,
            randomImage.id
          )}
          className="nav-button"
          aria-label="Save meme"
        >
          <img alt="" className="save-button" src={saveButton} />
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={chooseRandom}
          className="nav-button"
          aria-label="Next meme"
        >
          <img alt="" className="arrow-button right" src={rightArrow} />
        </motion.button>
      </div>
    </div>
  );
}
